import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Flex } from 'reflexbox/styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import media from 'media'
import theme from 'theme'
import { isFeatureNew } from 'helpers/feature'

import UniversalLink from 'components/UniversalLink'

const MarketingIcon = styled(Box).attrs({ width: 64, height: 64, mb: 8 })``

const MarketingIconImage = styled(GatsbyImage)`
  width: 100%;
  height: auto;
  flex-shrink: 0;

  ${media.desktop`
    width: 64px;
    height: 64px;
  `}
`

const CoverImage = styled(GatsbyImage)`
  width: 100%;
  margin-bottom: 8px;
  margin-left: -22px;
  width: calc(100% + 44px);
  margin-top: -22px;
  height: auto;

  ${media.desktop`
    height: 86px;
  `}
`

const FeatureTitle = styled(Box).attrs({
  fontSize: 18,
  fontWeight: theme.fontWeights.bold,
  mb: 8,
})``

const FeatureDescription = styled(Box).attrs({ fontSize: 13, mb: 24 })``

export const StyledUniversalLink = styled(UniversalLink)`
  margin-top: auto;
`

const FeatureCard = styled(Flex).attrs({
  width: ['100%', 224, 295, 262],
  p: 22,
  bg: theme.colors.white,
  flexDirection: ['column'],
})`
  position: relative;
  border: 2px solid ${theme.colors.blacks[10]};
`

const InfoContainer = styled(Flex).attrs({
  flexDirection: 'column',
  alignItems: 'flex-end',
})`
  position: absolute;
  z-index: 1;
  top: 5px;
  right: 5px;
  gap: 5px;
`

const Badge = styled(Box).attrs({
  bg: theme.colors.white,
  lineHeight: 1.5,
  px: '6px',
  py: '1px',
  width: 'fit-content',
})`
  border-radius: 100px;
  text-transform: uppercase;
  font-weight: ${theme.fontWeights.bold};
  border: 1px solid ${theme.colors.blacks[10]};
  font-size: 10px;
`

const BundleSummary = ({ feature, ...rest }) => {
  return (
    <FeatureCard {...rest}>
      <InfoContainer>
        {isFeatureNew(feature) && <Badge new>🔥 NEW</Badge>}
        <Badge>{feature.pricingPlan?.[0] ?? ''}</Badge>
      </InfoContainer>
      {feature.marketingIcon ? (
        <MarketingIcon>
          {feature.marketingIcon && (
            <MarketingIconImage
              image={getImage(feature.marketingIcon.asset.gatsbyImageData)}
            />
          )}
        </MarketingIcon>
      ) : (
        <CoverImage
          image={getImage(feature.coverImage.asset.gatsbyImageData)}
        />
      )}
      <FeatureTitle>{feature.name}</FeatureTitle>
      <FeatureDescription>{feature.description}</FeatureDescription>
      {feature.docsLink && (
        <StyledUniversalLink to={feature.docsLink.path} target="_blank">
          Learn More
        </StyledUniversalLink>
      )}
    </FeatureCard>
  )
}

BundleSummary.propTypes = {
  feature: PropTypes.object,
}

export default BundleSummary
